
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"-.75","y":".75","width":"5.5","height":"4.5","rx":"1.25","transform":"matrix(1 0 0 -1 10.5 9.5)","stroke":"#A4A8C0","stroke-width":"1.5"}}),_c('rect',{attrs:{"x":"2.75","y":"15.25","width":"4.546","height":"4.5","rx":"1.25","stroke":"#A4A8C0","stroke-width":"1.5"}}),_c('rect',{attrs:{"x":"10.227","y":"15.25","width":"4.546","height":"4.5","rx":"1.25","stroke":"#A4A8C0","stroke-width":"1.5"}}),_c('rect',{attrs:{"x":"17.704","y":"15.25","width":"4.546","height":"4.5","rx":"1.25","stroke":"#A4A8C0","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M12.64 8v7.657M5 16v-3a1 1 0 011-1h13a1 1 0 011 1v3","stroke":"#A4A8C0","stroke-width":"1.5"}})])
          )
        }
      }
    